module.exports = __webpack_public_path__ + "static/media/question.299fe502.svg";